module.exports = "/_next/static/images/PropCardCta@2x-02037bace8d4bab9aab06786e90adce4.png";